import store from '@/store'
import {trim} from 'lodash'
import {firstNonEmpty} from '@/utils/arrays'
import {shortenizeFullName} from '@/utils/misc'

export const PermissionType = {
  START: 'START',
  MF_SHOW_FREIGHT_DATES_LIST: 'MF_SHOW_FREIGHT_DATES_LIST',
  RESTART_PROCESSED_FREIGHT: 'RESTART_PROCESSED_FREIGHT',
  DELETE_FINISHED_FREIGHT: 'DELETE_FINISHED_FREIGHT'
}

export function hasRole (role) {
  return store.getters.user.roles && (store.getters.user.roles.indexOf(role) >= 0)
}
export function hasPermission (permission) {
  return store.getters.user.permissions && (store.getters.user.permissions.includes(permission))
}
export function updateRoleUsers (role) {
  return store.dispatch('user/updateRoleUsers', role)
}
export function getRoleUsers (role) {
  // console.log('store.getters.user: %o', store.getters.user.roleUsers)
  return [...(store.getters.user.roleUsers[role] || [])]
}
export function getRoleUserById (role, id) {
  const res = getRoleUsers(role).filter(u => u.id === id)
  return res.length > 0 ? res[0] : null
}
export function getRoleUsersByPortId (role, portId) {
  return getRoleUsers(role).filter(u => (u.userData['[PORTS]'] || []).includes('' + portId))
}
export function filterUsers (role, query) {
  // TODO: limit max results
  let searchQuery = trim(query).toUpperCase()
  if (searchQuery === '') {
    // console.log('getRoleUsers(role): %o', getRoleUsers(role))
    return getRoleUsers(role)
  }

  return getRoleUsers(role).filter(u => {
    return u.labels.searchString.indexOf(searchQuery) >= 0
  })
}
export function getUserLabels (user, lng) {
  const fullName = (lng === 'ru') ? firstNonEmpty(user.name, user.nameEn) : firstNonEmpty(user.nameEn, user.name)
  return {
    'value': user.id,
    'fullName': fullName,
    'shortName': shortenizeFullName(fullName),
    'searchString': ('' + '|' + user.name + '|' + user.nameEn + '|' + user.username).toUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/utils/user.js